import { AlertTriangle } from 'lucide-react';

export default function LateNightHabitModal({ habitName, currentDayId, onConfirm, onCancel }) {
  // currentDayId is "YYYY-MM-DD"
  const today = new Date(currentDayId + 'T12:00:00');
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  const formatOptions = { month: 'short', day: 'numeric' };
  const todayFormatted = today.toLocaleDateString('en-US', formatOptions);
  const yesterdayFormatted = yesterday.toLocaleDateString('en-US', formatOptions);

  const yesterdayDayId = yesterday.toISOString().split('T')[0];

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onCancel} />
      <div className="relative bg-white rounded-3xl w-full max-w-sm shadow-2xl overflow-hidden animate-in fade-in zoom-in-95 duration-200">
        <div className="bg-amber-50 p-6 flex flex-col items-center text-center gap-4 border-b border-amber-100">
          <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center text-amber-500">
            <AlertTriangle size={32} strokeWidth={2.5} />
          </div>
          <div>
            <h2 className="text-xl font-black text-amber-900 tracking-tight mb-1">Late Night Check-in!</h2>
            <p className="text-sm font-semibold text-amber-700/80">It's between midnight and 5 AM.</p>
          </div>
        </div>
        
        <div className="p-6">
          <p className="text-center text-zinc-600 text-sm font-medium mb-6">
            You're checking off <strong className="text-zinc-900">"{habitName}"</strong>. Which day did you mean to log this for?
          </p>
          
          <div className="flex flex-col gap-3">
            <button 
              onClick={() => onConfirm(currentDayId)}
              className="w-full py-3.5 bg-zinc-100 hover:bg-zinc-200 text-zinc-800 rounded-xl font-bold tracking-wide transition-colors"
            >
              Today ({todayFormatted})
            </button>
            <button 
              onClick={() => onConfirm(yesterdayDayId)}
              className="w-full py-3.5 bg-amber-500 hover:bg-amber-600 text-white rounded-xl font-bold tracking-wide transition-colors shadow-sm"
            >
              Yesterday ({yesterdayFormatted})
            </button>
            <button 
              onClick={onCancel}
              className="w-full mt-2 py-2 text-zinc-400 hover:text-zinc-600 text-sm font-semibold transition-colors"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
